
<main>
    <div class="city-search">
        <div class="filtering">
            <form>
                <input type="search" class="form-control" #filter (keyup)="searchMember($event)"
                    placeholder="સભ્યો શોધો.." />
                <i class="ti ti-search"></i>
            </form>
            <!-- <i class="ti ti-filter cursorClass" (click)="openBottomSheet()"></i>
            <a class="ti ti-refresh cursorClass" (click)="getCommitMember()"></a>           -->
        </div>
    </div>
    <div>
        <div class="form-group">
            <select class="form-control" [(ngModel)]="selectedYear" (change)="onYearChange($event)">
                <option hidden value="" disabled selected>Year</option>
                <option *ngFor="let data of year" [value]="data.years">
                    {{data.years}}
                </option>
            </select>
        </div>
    </div>
    <mat-tab-group mat-stretch-tabs="true" mat-align-tabs="center" [(selectedIndex)]="selectedTabIndex"
        (selectedIndexChange)="onTabChanged($event)">
        <mat-tab label="કારોબારી કમિટી">
            <div *ngIf="commitDataLength != 0" class="main-members family-tabs">
                <a *ngFor="let member of commitData" class="member-list-item">
                    <ng-container [ngSwitch]="member.image !== ''">
                        <img *ngSwitchCase="true" [src]="baseUrl + member.image" />
                        <img *ngSwitchCase="false" src="../../../assets/img/user_.jpg" />
                    </ng-container>
                    <div>
                        <h5>{{ member.name }}</h5>
                        <p>{{ member.contact_no }} </p>
                        <p>{{member.business}}<span *ngIf="member.business && member.village_name">|</span>
                            {{member.village_name }}</p>
                    </div>
                </a>
            </div>
        </mat-tab>

        <mat-tab label="યુવા કમિટી">
            <div *ngIf="commitDataLength != 0" class="main-members family-tabs">
                <a *ngFor="let member of commitData" class="member-list-item">
                    <ng-container [ngSwitch]="member.image !== ''">
                        <img *ngSwitchCase="true" [src]="baseUrl + member.image" />
                        <img *ngSwitchCase="false" src="../../../assets/img/user_.jpg" />
                    </ng-container>
                    <div>
                        <h5>{{ member.name }}</h5>
                        <p>{{ member.contact_no }} </p>
                        <p>{{member.business}}<span *ngIf="member.business && member.village_name">|</span>
                            {{member.village_name }}</p>
                    </div>
                </a>
            </div>
        </mat-tab>

        <mat-tab label="સ્ટુડન્ટ કમિટી">
            <div *ngIf="commitDataLength != 0" class="main-members family-tabs">
                <a *ngFor="let member of commitData" class="member-list-item">
                    <ng-container [ngSwitch]="member.image !== ''">
                        <img *ngSwitchCase="true" [src]="baseUrl + member.image" />
                        <img *ngSwitchCase="false" src="../../../assets/img/user_.jpg" />
                    </ng-container>
                    <div>
                        <h5>{{ member.name }}</h5>
                        <p>{{ member.contact_no }} </p>
                        <p>{{member.business}}<span *ngIf="member.business && member.village_name">|</span>
                            {{member.village_name }}</p>
                    </div>
                </a>
            </div>
        </mat-tab>
    </mat-tab-group>
    <div *ngIf="commitDataLength == 0" class="text-center">
        <span class="text-danger ">No Data Found</span>
    </div>
</main>